import { Link } from "react-router-dom";
import { ReactNode } from "react";
import classNames from "classnames";

interface NavigationLinkBtnProps {
  label: string | ReactNode;
  to: string;
  className?: string;
}

const NavigationLinkBtn: React.FC<NavigationLinkBtnProps> = ({ label, to, className }) => {
  const classes = classNames(
    "bg-primary text-white font-bold p-2 m-4 w-min whitespace-nowrap rounded",
    className
  );
  
  return (
    <Link
      to={to}
      className={classes}
    >
      {label}
    </Link>
  );
};

export default NavigationLinkBtn;
